<template>
  <div
    class="col img-preview"
    style="width: 100%; height: 100%; position: relative;"
  >
    <q-inner-loading
      v-if="isLoading"
      :showing="true"
    >
      <q-spinner-ios
        size="30px"
        color="primary"
      />
    </q-inner-loading>

    <div
      v-else
      v-once
      class="row items-center"
    >
      <div class="column items-center col">
        <div :class="`row items-center justify-center ${reverse ? 'reverse' : ''}`">
          <q-img
            :src="url"
            :basic="true"
            spinner-color="#ddd"
            style="width: 200px;"
            fit="contain"
            :class="['col-auto', textBorder(msg)]"
            v-img="configImg"
          />
        </div>

        <template v-if="$scopedSlots['msg']">
          <div class="col-auto q-pb-xs">
            <slot name="msg" />
          </div>
        </template>
      </div>
    </div>
  </div>
</template>

<script>
import Vue from 'vue'
import { checkURL } from '@/libs/hasURL'
import VueImg from 'v-img'

Vue.use(VueImg, {
  group: 'group',
  sourceButton: false,
  openOn: 'click'
})

export default {
  props: {
    url: {},
    msg: {},
    name: {},
    reverse: {}
  },

  data () {
    return {
      isLoading: true
    }
  },

  mounted () {
    this.isMounted = true
    checkURL(this, this.url)
  },

  beforeDestroy () {
    this.isMounted = false
  },

  computed: {
    configImg () {
      const vm = this
      return {
        src: vm.url,
        title: vm.name
      }
    }
  },

  methods: {
    textBorder (msg) {
      return msg.direction === 'IN' ? 'item-border-in' : 'item-border-out'
    }
  }
}
</script>
